import React, { useState } from 'react';
import { useSnackbarContext } from 'Context/SnackbarContext';
import {
  FDBodyText,
  FDBox,
  FDConfirmationDialog, FDDeleteButton,
  FDIcon,
  FDPaper,
  FDSecondaryActionIconButton,
  FDStack,
} from '@facet-wealth/design';
import { noop } from 'Helpers/PropTypes';
import PropTypes from 'prop-types';
import { dataAttrs } from 'Helpers/Testing';

const ViewableListItem = ({
  icon, confirmOnDelete, onDelete, onView, iconColor, itemText, canDelete,
}) => {
  const [deleting, setDeleting] = useState(false);
  const [open, setOpen] = useState(false);
  const { displayErrorMessage } = useSnackbarContext();

  const onClose = () => {
    setOpen(false);
  };

  const handleDelete = async () => {
    if (confirmOnDelete && !open) {
      setOpen(true);
      return;
    }

    setDeleting(true);
    try {
      await onDelete();
    } catch (e) {
      displayErrorMessage(e, e.errors[0]?.detail || 'Unable to delete the document');
    } finally {
      setDeleting(false);
    }
  };
  return (
    <FDPaper appearance={'outlined'} color={'subtle'} {...dataAttrs('viewable-list-item')}>
      <>
        <FDConfirmationDialog
          title="Are you sure?"
          message={'You are about to delete this. This action cannot be undone.'}
          confirmLabel="Confirm"
          open={open}
          onConfirm={handleDelete}
          onClose={onClose}
          loading={deleting}
        />
        <FDStack paddingY={1} paddingX={2} direction={'row'} spacing={2} alignItems={'center'}>
          {icon !== '' ? <FDIcon icon={icon} size={'sm'} color={iconColor} /> : null }
          <FDBox flex={1}>
            <FDBodyText value={itemText} maxLines={2} />
          </FDBox>
          <FDStack>
            <FDSecondaryActionIconButton
              onClick={onView}
              icon={'visibility'}
              label={'View'}
              {...dataAttrs('viewable-list-item-view-btn')}
            />
            {canDelete
              ? <FDDeleteButton
                loading={deleting}
                onClick={handleDelete}
                label={'Delete'}
                appearance={'secondary'}
                {...dataAttrs('viewable-list-item-delete-btn')}
              /> : null
            }
          </FDStack>
        </FDStack>
      </>
    </FDPaper>
  );
};

ViewableListItem.defaultProps = {
  icon: '',
  onDelete: noop,
  onView: noop,
  confirmOnDelete: false,
  iconColor: 'textPrimary',
  itemText: '',
  canDelete: true,
};

ViewableListItem.propTypes = {
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  onDelete: PropTypes.func,
  onView: PropTypes.func,
  confirmOnDelete: PropTypes.bool,
  itemText: PropTypes.string,
  canDelete: PropTypes.bool,
};

export { ViewableListItem };
